/**
 * theme.js - Main theme JavaScript
 * Event delegation, cart drawer control, gallery navigation
 * Uses IIFEs + CustomEvents, no globals
 */
(function() {
  'use strict';

  function initQuantityInputs() {
    document.addEventListener('click', function(e) {
      const minusBtn = e.target.closest('[data-qty-minus]');
      const plusBtn = e.target.closest('[data-qty-plus]');
      
      if (minusBtn) {
        e.preventDefault();
        const container = minusBtn.closest('.qty-input');
        const input = container ? container.querySelector('input[type="number"]') : null;
        if (input) {
          const currentVal = parseInt(input.value, 10) || 1;
          const minVal = parseInt(input.min, 10) || 1;
          if (currentVal > minVal) {
            input.value = currentVal - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
      
      if (plusBtn) {
        e.preventDefault();
        const container = plusBtn.closest('.qty-input');
        const input = container ? container.querySelector('input[type="number"]') : null;
        if (input) {
          const currentVal = parseInt(input.value, 10) || 1;
          const maxVal = input.max ? parseInt(input.max, 10) : Infinity;
          if (currentVal < maxVal) {
            input.value = currentVal + 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });
  }

  function initGallery() {
    document.addEventListener('click', function(e) {
      const thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      
      e.preventDefault();
      
      const gallery = thumb.closest('[data-product-gallery]');
      if (!gallery) return;
      
      const index = parseInt(thumb.dataset.index, 10);
      const scrollContainer = gallery.querySelector('[data-gallery-scroll]');
      const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      
      if (scrollContainer) {
        const slideWidth = scrollContainer.offsetWidth;
        scrollContainer.scrollTo({
          left: index * slideWidth,
          behavior: 'smooth'
        });
      }
      
      thumbs.forEach(function(t, i) {
        t.classList.toggle('is-active', i === index);
      });
    });

    document.querySelectorAll('[data-gallery-scroll]').forEach(function(scrollContainer) {
      let scrollTimeout;
      
      scrollContainer.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function() {
          const gallery = scrollContainer.closest('[data-product-gallery]');
          if (!gallery) return;
          
          const slideWidth = scrollContainer.offsetWidth;
          const scrollLeft = scrollContainer.scrollLeft;
          const activeIndex = Math.round(scrollLeft / slideWidth);
          
          const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
          thumbs.forEach(function(t, i) {
            t.classList.toggle('is-active', i === activeIndex);
          });
        }, 50);
      }, { passive: true });
    });
  }

  function initSmoothScroll() {
    document.addEventListener('click', function(e) {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      
      const href = anchor.getAttribute('href');
      if (href === '#' || href.length < 2) return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var overlay = document.querySelector('[data-menu-overlay]');
    if (!menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-open');
      document.body.classList.add('menu-open');
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }

    // Open/close menu
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-menu-open]')) {
        e.preventDefault();
        openMenu();
      }
      if (e.target.closest('[data-menu-close]') || e.target.closest('[data-menu-overlay]')) {
        e.preventDefault();
        closeMenu();
      }
    });

    // Expandable nav items
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-nav-toggle]');
      if (!toggle) return;
      
      e.preventDefault();
      var parent = toggle.closest('[data-nav-parent]');
      if (!parent) return;
      
      var children = parent.querySelector('[data-nav-children]');
      if (!children) return;
      
      var isOpen = toggle.classList.contains('is-open');
      
      // Close all other open items
      document.querySelectorAll('[data-nav-toggle].is-open').forEach(function(openToggle) {
        if (openToggle !== toggle) {
          openToggle.classList.remove('is-open');
          var openChildren = openToggle.closest('[data-nav-parent]').querySelector('[data-nav-children]');
          if (openChildren) openChildren.hidden = true;
        }
      });
      
      toggle.classList.toggle('is-open', !isOpen);
      children.hidden = isOpen;
    });

    // Bestsellers slider navigation
    var slider = document.querySelector('[data-bestsellers-slider]');
    var prevBtn = document.querySelector('[data-bestsellers-prev]');
    var nextBtn = document.querySelector('[data-bestsellers-next]');
    
    if (slider && prevBtn && nextBtn) {
      var scrollAmount = 160;
      
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    // Close menu on escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });

    // Close menu when clicking a link
    menu.addEventListener('click', function(e) {
      if (e.target.closest('a:not([data-nav-toggle])')) {
        closeMenu();
      }
    });
  }

  function init() {
    initQuantityInputs();
    initGallery();
    initSmoothScroll();
    initMobileMenu();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function() {
  function getMoneyFormat() {
    var meta = document.querySelector('meta[name="money-format"]');
    return meta ? meta.getAttribute('content') : '${{amount}}';
  }

  function addThousands(value, separator) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);
    if (!Number.isFinite(cents)) cents = 0;
    var format = getMoneyFormat();
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value = cents / 100;
    var formatted;
    switch (match[1]) {
      case 'amount':
        formatted = addThousands(value.toFixed(2), ',');
        break;
      case 'amount_no_decimals':
        formatted = addThousands(Math.round(value), ',');
        break;
      case 'amount_with_comma_separator':
        formatted = addThousands(value.toFixed(2).replace('.', ','), '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = addThousands(Math.round(value), '.');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = addThousands(value.toFixed(2), "'");
        break;
      default:
        formatted = value.toFixed(2);
    }
    return format.replace(match[0], formatted);
  }

  function parseLegacyAmount(value) {
    var raw = String(value || '').replace(/\s/g, '');
    var comma = raw.lastIndexOf(',');
    var dot = raw.lastIndexOf('.');
    if (comma > dot) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else {
      raw = raw.replace(/,/g, '');
    }
    var number = Number(raw.replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) ? Math.round(number * 100) : null;
  }

  function normalizeMoneyText(text) {
    var next = String(text || '');
    var shippingPrice = formatMoney(495);
    var shippingThreshold = formatMoney(3000);
    next = next.replace(/(^|[^\d])((?:€|\$|USD|EUR)?\s*(?:2|4|5)[,.]95\s*(?:€|\$|USD|EUR)?)(?!\d)/gi, function(match, prefix) { return prefix + shippingPrice; });
    next = next.replace(/free with\s+[23]\s+items?/gi, 'free from ' + shippingThreshold);
    next = next.replace(/offerte dès\s+[23]\s+articles/gi, 'offerte dès ' + shippingThreshold);
    next = next.replace(/Livraison offerte dès\s+[23]\s+articles/gi, 'Livraison offerte dès ' + shippingThreshold);
    next = next.replace(/Your order funds 10 meals\./g, 'This bracelet funds 10 meals.');
    next = next.replace(/Your order funds/g, 'Your selection funds');
    next = next.replace(/10 meals donated with this order/g, '10 meals donated with this bracelet');
    next = next.replace(/Votre commande finance 10 repas\./g, 'Ce bracelet finance 10 repas.');
    next = next.replace(/Votre commande finance/g, 'Votre sélection finance');
    next = next.replace(/0,00\s*\u20ac/g, formatMoney(0));
    next = next.replace(/(\d+(?:[.,]\d{3})*[.,]\d{2})\s*(?:\$US|USD)/g, function(match, amount) {
      var cents = parseLegacyAmount(amount);
      return cents === null ? match : formatMoney(cents);
    });
    return next;
  }

  function normalizeRoot(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var normalized = normalizeMoneyText(node.nodeValue);
      if (normalized !== node.nodeValue) node.nodeValue = normalized;
    }
  }

  function normalizeVisibleMoney() {
    var roots = document.querySelectorAll('.sz-bundle, #pvImpactLine, .pv-sticky-bundle__copy, #pvAtcPrice');
    roots.forEach(function(root) { normalizeRoot(root); });
  }

  function initMoneyFormatGuard() {
    normalizeVisibleMoney();
    if (!document.body || !window.MutationObserver) return;
    var queued = false;
    var observer = new MutationObserver(function() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function() {
        queued = false;
        normalizeVisibleMoney();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMoneyFormatGuard);
  } else {
    initMoneyFormatGuard();
  }
})();

(function() {
  function cleanEmailPopupCache() {
    if (!document.querySelector('[data-sz-email-popup]')) return;

    if (!document.getElementById('szEmailPopupCacheFix')) {
      var style = document.createElement('style');
      style.id = 'szEmailPopupCacheFix';
      style.textContent = '.szp [hidden]{display:none!important}.szp__legal{display:none!important}';
      document.head.appendChild(style);
    }

    document.querySelectorAll('.szp__legal').forEach(function(node) {
      node.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanEmailPopupCache);
  } else {
    cleanEmailPopupCache();
  }
})();

(function() {
  function initFiveReasonsCacheGuard() {
    if (window.location.pathname.indexOf('/pages/5-reasons-this-isnt-just-a-bracelet') === -1) return;
    var page = document.querySelector('.sz5-page');
    if (!page) return;

    var staleProducts = page.querySelector('.sz5-products');
    if (staleProducts) staleProducts.remove();

    var reviewImages = page.querySelectorAll('.sz5-reviews .sz5-review img');
    var reviewAssets = [
      'sz-five-reasons-review-pouch-stack.webp',
      'sz-five-reasons-review-pouch-bracelet.webp',
      'sz-five-reasons-review-pouch-grid.webp'
    ];
    reviewAssets.forEach(function(asset, offset) {
      var img = reviewImages[reviewImages.length - reviewAssets.length + offset];
      if (!img || img.src.indexOf(asset) !== -1) return;
      var assetBase = img.src.indexOf('/assets/') !== -1 ? img.src.replace(/[^/?#]+(?:[?#].*)?$/, '') : '/cdn/shop/assets/';
      img.src = assetBase + asset;
      img.srcset = '';
      img.width = 1080;
      img.height = 1080;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFiveReasonsCacheGuard);
  } else {
    initFiveReasonsCacheGuard();
  }
})();

(function() {
  function injectProductStyles() {
    if (document.getElementById('sz-product-cache-guard-styles')) return;
    var style = document.createElement('style');
    style.id = 'sz-product-cache-guard-styles';
    style.textContent = [
      '.pv-pdp-accordions{margin-top:16px;border-top:1px solid var(--pv-line)}',
      '.pv-pdp-accordions details{border-bottom:1px solid var(--pv-line);border-top:0}',
      '.pv-pdp-accordions summary{display:flex;justify-content:space-between;gap:16px;padding:16px 0;cursor:pointer;color:var(--pv-text);font-weight:500}',
      '.pv-pdp-accordions summary:after{content:"+";flex:0 0 auto;color:var(--pv-green);font-size:20px;line-height:1}',
      '.pv-pdp-accordions details[open] summary:after{content:"-"}',
      '.pv-acc-content{padding:0 0 18px}.pv-acc-content p{margin:0 0 14px;color:var(--pv-muted);font-size:14px;line-height:1.62}.pv-acc-content strong{color:var(--pv-text);font-weight:850}.pv-acc-lead{font-size:15px}',
      '.pv-acc-grid{display:grid;gap:8px;margin:12px 0 14px}.pv-acc-grid span{position:relative;padding:10px 12px 10px 30px;border-radius:8px;background:#f8f4ec;color:var(--pv-text);font-size:13px;line-height:1.35;font-weight:500}.pv-acc-grid span:before{content:"";position:absolute;left:12px;top:15px;width:7px;height:7px;border-radius:50%;background:var(--pv-green)}',
      '.pv-pdp-benefits li{font-weight:500!important}',
      '.pv-guarantee-points{font-weight:500!important}',
      '.pv-mini-reviews{margin-top:16px;padding:15px;border:1px solid var(--pv-line);border-radius:10px;background:#fffaf1;overflow:hidden}.pv-mini-reviews__head{display:flex;align-items:flex-start;justify-content:space-between;gap:14px;margin-bottom:12px}.pv-mini-reviews__head p{margin:0;color:var(--pv-muted);font-size:12.5px;line-height:1.45;max-width:300px}.pv-mini-reviews__viewport{overflow:hidden}.pv-mini-reviews__track{display:flex;transition:transform .45s ease;will-change:transform}.pv-mini-reviews article{flex:0 0 100%;padding:16px;border:1px solid #e4ded3;border-radius:8px;background:#fff}.pv-mini-reviews article strong{display:block;margin-bottom:8px;color:var(--pv-text);font-size:15px;line-height:1.28;font-weight:850}.pv-mini-reviews article p{margin:0 0 12px;color:var(--pv-muted);font-size:13.5px;line-height:1.55}.pv-mini-reviews article span{color:var(--pv-green);font-size:12px;font-weight:750}.pv-mini-reviews__dots{display:flex;justify-content:center;gap:6px;margin-top:11px}.pv-mini-reviews__dots span{width:6px;height:6px;border-radius:999px;background:#d9d0c2;transition:width .25s ease,background .25s ease}.pv-mini-reviews__dots span.active{width:18px;background:var(--pv-green)}'
    ].join('');
    document.head.appendChild(style);
  }

  function initMiniReviewCarousel(root) {
    root.querySelectorAll('[data-pv-mini-reviews]').forEach(function(widget) {
      if (widget.dataset.ready) return;
      widget.dataset.ready = 'true';
      var track = widget.querySelector('.pv-mini-reviews__track');
      var slides = Array.prototype.slice.call(widget.querySelectorAll('article'));
      var dots = Array.prototype.slice.call(widget.querySelectorAll('.pv-mini-reviews__dots span'));
      if (!track || slides.length < 2) return;
      var current = 0;
      function go(next) {
        current = (next + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-current * 100) + '%)';
        dots.forEach(function(dot, i) { dot.classList.toggle('active', i === current); });
      }
      var timer = setInterval(function() { go(current + 1); }, 5000);
      widget.addEventListener('mouseenter', function() { clearInterval(timer); });
      widget.addEventListener('mouseleave', function() { timer = setInterval(function() { go(current + 1); }, 5000); });
      dots.forEach(function(dot, i) { dot.addEventListener('click', function() { go(i); }); });
    });
  }

  function getProductFamily() {
    var title = (document.querySelector('.pv-pdp-title')?.textContent || '').toLowerCase();
    if (title.indexOf('collana') !== -1 || title.indexOf('necklace') !== -1) return 'collana';
    if (title.indexOf('orecchini') !== -1 || title.indexOf('earrings') !== -1) return 'orecchini';
    if (title.indexOf('ciotola') !== -1 || title.indexOf('bowl') !== -1 || title.indexOf('cane') !== -1 || title.indexOf('dog') !== -1) return 'accessorio_cane';
    if (title.indexOf('pochette') !== -1 || title.indexOf('gift pouch') !== -1) return 'pochette';
    if (title.indexOf('adesivi') !== -1 || title.indexOf('stickers') !== -1) return 'adesivi';
    if (title.indexOf('club') !== -1) return 'club';
    if (title.indexOf('miyuki') !== -1) return 'miyuki';
    if (title.indexOf('albero') !== -1 || title.indexOf('tree of life') !== -1) return 'albero';
    return 'bracciale';
  }

  function productAccordionMarkup(family) {
    var detail;
    if (family === 'collana') {
      detail = '<p class="pv-acc-lead"><strong>This necklace keeps the cause close to your heart</strong>, without becoming a flashy piece of jewellery.</p><div class="pv-acc-grid"><span>A delicate symbol that is easy to match.</span><span>An emotional gift for anyone who loves animals.</span><span>Thoughtful mywoobles presentation.</span></div><p>It is the kind of necklace that works because it is not only about style. It tells a story of connection, sensitivity and a concrete gesture.</p>';
    } else if (family === 'orecchini') {
      detail = '<p class="pv-acc-lead"><strong>These earrings add a bright detail with meaningful purpose</strong>, easy to wear in everyday life.</p><div class="pv-acc-grid"><span>Subtle, balanced design.</span><span>Easy to gift and easy to wear.</span><span>mywoobles message tied to the order.</span></div><p>A small accessory can feel much more personal when it carries a gesture for animals in need.</p>';
    } else if (family === 'accessorio_cane') {
      detail = '<p class="pv-acc-lead"><strong>This accessory is designed to help with your dog’s routine</strong>, while staying connected to the mywoobles mission.</p><div class="pv-acc-grid"><span>Useful in your dog’s everyday life.</span><span>Practical, not just symbolic.</span><span>Each bracelet contributes 10 meals.</span></div><p>It combines immediate usefulness with impact: you help your dog today while supporting other animals waiting for care and food.</p>';
    } else if (family === 'pochette') {
      detail = '<p class="pv-acc-lead"><strong>The pouch turns a piece of jewellery into a finished gift</strong>, more thoughtful and more pleasant to receive.</p><div class="pv-acc-grid"><span>Cleaner presentation.</span><span>Ideal for a last-minute gift.</span><span>Consistent with the mywoobles world.</span></div><p>When the meaning matters, the way you offer it matters too. The pouch avoids the feeling of a product handed over as-is.</p>';
    } else if (family === 'adesivi') {
      detail = '<p class="pv-acc-lead"><strong>mywoobles stickers bring the mission message onto everyday objects</strong>, with a simple, accessible purchase.</p><div class="pv-acc-grid"><span>Easy to use or gift.</span><span>Perfect for personalizing small objects.</span><span>Connected to the 10-meal mission.</span></div><p>A light detail for anyone who wants to show their love for animals without buying jewellery.</p>';
    } else if (family === 'club') {
      detail = '<p class="pv-acc-lead"><strong>The Monthly Club is for people who want to help consistently</strong>, not only when buying a gift.</p><div class="pv-acc-grid"><span>Recurring support for the mission.</span><span>More consistent impact over time.</span><span>A simple gesture to maintain.</span></div><p>It is the more consistent choice for anyone who feels helping animals should not remain an occasional gesture.</p>';
    } else if (family === 'miyuki') {
      detail = '<p class="pv-acc-lead"><strong>Each Miyuki bracelet helps fund 10 meals</strong> for animals in need.</p><div class="pv-acc-grid"><span>Fine, luminous Miyuki beads.</span><span>Adjustable, lightweight and easy to wear.</span><span>mywoobles pouch included.</span></div><p>The strength of Miyuki is in the color: delicate on the wrist, but full of personality without losing the meaning behind the gift.</p>';
    } else if (family === 'albero') {
      detail = '<p class="pv-acc-lead"><strong>Each Tree of Life bracelet helps fund 10 meals</strong> for animals in need.</p><div class="pv-acc-grid"><span>Symbolic charm of protection and renewal.</span><span>Adjustable, lightweight and easy to wear.</span><span>mywoobles pouch included.</span></div><p>It is made for people who love lasting symbols: roots, protection and a second chance.</p>';
    } else {
      detail = '<p class="pv-acc-lead"><strong>Each bracelet helps fund 10 meals</strong> for animals in need.</p><div class="pv-acc-grid"><span>Adjustable, lightweight and easy to wear.</span><span>Subtle paw detail, not childish.</span><span>mywoobles pouch included.</span></div><p>A simple symbol for anyone who wants to wear something that is not only decorative: a daily reminder of the bond with animals waiting for a second chance.</p>';
    }
    return [
      '<details><summary>Product details</summary><div class="pv-acc-content">' + detail + '</div></details>',
      '<details><summary>Meaningful impact</summary><div class="pv-acc-content"><p><strong>The promise is clear:</strong> every bracelet helps fund 10 meals. You do not need to buy a lot to make a concrete gesture: even this product can become food, care and attention.</p><p>The product is still beautiful to receive, but it carries one more reason to choose it.</p></div></details>',
      '<details><summary>Shipping and returns</summary><div class="pv-acc-content"><p>Your selection is prepared with care and shipped with tracking. If something is not what you expected, you have <strong>30 days</strong> to contact us and find the simplest solution.</p></div></details>'
    ].join('');
  }

  function productMiniReviewsMarkup() {
    return [
      '<div class="pv-mini-reviews" data-pv-mini-reviews aria-label="Reviews mywoobles">',
        '<div class="pv-mini-reviews__head"><span class="pv-stars">★★★★★</span><p>Stories from people who chose a purchase with more meaning.</p></div>',
        '<div class="pv-mini-reviews__viewport"><div class="pv-mini-reviews__track">',
          '<article><strong>“You can tell right away it was not a random purchase.”</strong><p>The symbol, the presentation and the message about donated meals made everything feel more personal.</p><span>Giulia R.</span></article>',
          '<article><strong>“Small, but with a story behind it.”</strong><p>I chose it because I wanted an accessible gift that said something real.</p><span>Valentina S.</span></article>',
          '<article><strong>“It arrived with meaning, not just a price.”</strong><p>It is a simple product, but the connection to 10 meals makes it much easier to choose.</p><span>Federica L.</span></article>',
          '<article><strong>“The 10-meal part made the difference.”</strong><p>It was the detail that turned an accessible product into an emotional gesture.</p><span>Alessia P.</span></article>',
        '</div></div>',
        '<div class="pv-mini-reviews__dots" aria-hidden="true"><span class="active"></span><span></span><span></span><span></span></div>',
      '</div>'
    ].join('');
  }

  function productFaqMarkup(family) {
    var firstQ = 'Why does this feel better than an ordinary gift?';
    var firstA = 'Because it combines two reasons to buy in one gesture: it is an easy-to-use accessory and, at the same time, says something about the person who chooses it. You are not gifting only an object; you are gifting a symbol for someone who truly loves animals.';
    var thirdQ = 'I am worried it may feel cheap in person. How does it look?';
    var thirdA = 'The design is intentionally subtle: not heavy or flashy jewellery, but a symbolic piece you can wear often. The animal detail adds meaning without making it childish.';
    var fourthQ = 'Is it suitable if I do not know the size?';
    var fourthA = 'Yes, the product is designed to be easy to adjust or gift without too much hesitation. That is exactly what makes it suitable as a meaningful gift.';
    var giftA = 'Yes, the order is presented with care. You can give it without having to explain everything from scratch: the meaningful message already makes the moment more personal.';
    if (family === 'accessorio_cane') {
      firstQ = 'Why choose this instead of any ordinary accessory?';
      firstA = 'Because it combines usefulness and intention: it is genuinely useful in a dog’s routine while also supporting the 10-meal mission. It is not an anonymous extra; it is a coherent purchase for people who love animals.';
      thirdQ = 'Is it actually useful in a daily routine?';
      thirdA = 'Yes. The goal is to avoid a “cute but useless” purchase. It is designed for a real moment in your dog’s day, with a simple design that is easy to understand and use at home.';
      fourthQ = 'Is it suitable for every dog?';
      fourthA = 'It is designed for simple home use. As with any accessory, always check that it suits your dog’s habits and size before use.';
    } else if (family === 'pochette') {
      firstQ = 'Why add a pouch to the order?';
      firstA = 'Because presentation changes how the gift feels. A meaningful product deserves thoughtful presentation: the pouch makes the gesture more complete, more personal and immediately ready to give.';
      thirdQ = 'Does it really feel more thoughtful in person?';
      thirdA = 'Yes. Its role is simple: remove the “online order” feeling and give the product a cleaner, more intentional, easier-to-gift presentation.';
      fourthQ = 'Is it compatible with mywoobles jewellery?';
      fourthA = 'Yes, it is made to complete mywoobles bracelets, necklaces and earrings. It is the simplest detail for making the gift immediately presentable.';
      giftA = 'That is exactly why the pouch exists: to make the product feel more thoughtful and ready to give. It is a small detail, but it changes the final impression.';
    } else if (family === 'adesivi') {
      firstQ = 'Why add mywoobles stickers?';
      firstA = 'Because they are the simplest way to bring the mywoobles message into everyday life. They cost little, are easy to add and make the choice to support animals visible.';
      thirdQ = 'Where can I use the stickers?';
      thirdA = 'On a planner, laptop, bottle, gift package or everyday object. They are made to make the message visible without requiring someone to buy jewellery.';
      fourthQ = 'Is it a good small gift?';
      fourthA = 'Yes, especially for someone who loves animals but does not wear jewellery. It is small, accessible and easy to add to a bigger gift.';
    } else if (family === 'club') {
      firstQ = 'Why join the Club instead of placing a single order?';
      firstA = 'Because animals’ needs are not occasional. The Club turns an emotional gesture into regular support, which is more useful for giving the mission continuity.';
      thirdQ = 'Can I manage the monthly support easily?';
      thirdA = 'Yes. Support is designed to stay simple. If you need help, the team guides you without making management complicated.';
      fourthQ = 'Who is the Club for?';
      fourthA = 'It is made for people who want to help consistently, even when they do not need to buy a product. It is a steadier choice, not an impulse.';
      giftA = 'The Club is not physical packaging: it is support for the mission. If you also want a tangible gift, you can pair it with a mywoobles product.';
    }
    return [
      '<details><summary>' + firstQ + '</summary><p>' + firstA + '</p></details>',
      '<details><summary>Is the meal contribution really the heart of the product?</summary><p>Yes. The mywoobles promise is simple and repeated across the store: every bracelet helps fund 10 meals for animals in need. It is designed to make the purchase concrete, easy to understand and easy to explain to the person receiving the gift.</p></details>',
      '<details><summary>' + thirdQ + '</summary><p>' + thirdA + '</p></details>',
      '<details><summary>' + fourthQ + '</summary><p>' + fourthA + '</p></details>',
      '<details><summary>Does it arrive ready to gift?</summary><p>' + giftA + '</p></details>',
      '<details><summary>What if it is not what I expected when it arrives?</summary><p>You have 30 days to contact us. If something is not right, support will guide you to the simplest solution. The goal is for you to order without feeling like you are taking a risk.</p></details>'
    ].join('');
  }

  function initProductCacheGuard() {
    var info = document.querySelector('.pv-pdp-info');
    var accordions = document.querySelector('.pv-pdp-accordions');
    if (!info || !accordions) return;
    injectProductStyles();
    var family = getProductFamily();
    var staleAccordion = accordions.textContent.indexOf('Ogni bracciale contribuisce') !== -1 || accordions.textContent.indexOf('anche un bracciale') !== -1 || accordions.textContent.indexOf('Product details') !== -1 && accordions.querySelector('details[open]');
    if (!accordions.querySelector('.pv-acc-content') || staleAccordion) {
      accordions.innerHTML = productAccordionMarkup(family);
    } else {
      accordions.querySelectorAll('details[open]').forEach(function(detail) { detail.removeAttribute('open'); });
    }
    var miniReviews = info.querySelector('.pv-mini-reviews');
    if (!miniReviews) {
      accordions.insertAdjacentHTML('afterend', productMiniReviewsMarkup());
    } else if (miniReviews.textContent.indexOf('altri bracciali') !== -1 || miniReviews.textContent.indexOf('bracciale semplice') !== -1) {
      miniReviews.outerHTML = productMiniReviewsMarkup();
    }
    var faq = document.querySelector('.pv-faq');
    if (faq && (faq.textContent.indexOf('questo bracciale') !== -1 || faq.textContent.indexOf('misura del polso') !== -1 || faq.querySelector('details[open]'))) {
      faq.innerHTML = productFaqMarkup(family);
    }
    var guarantee = document.querySelector('.pv-guarantee-card');
    if (guarantee && !guarantee.querySelector('.pv-guarantee-media')) {
      guarantee.insertAdjacentHTML('beforeend', '<div class="pv-guarantee-media"><img src="/cdn/shop/t/9/assets/salva-team-event-dogs.webp?v=31901143389971173201781161846" alt="mywoobles team with rescued dogs during a meaningful event" width="1586" height="992" loading="lazy"></div>');
    }
    initMiniReviewCarousel(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCacheGuard);
  } else {
    initProductCacheGuard();
  }
})();

(function() {
  function money(value) {
    var amount = Number(value || 0);
    if (!Number.isFinite(amount)) amount = 0;
    var meta = document.querySelector('meta[name="money-format"]');
    var format = meta ? meta.getAttribute('content') : '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return format;
    var cents = Math.round(amount * 100);
    var value = cents / 100;
    var formatted;
    switch (match[1]) {
      case 'amount':
        formatted = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_no_decimals':
        formatted = String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        break;
      case 'amount_with_comma_separator':
        formatted = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        break;
      default:
        formatted = value.toFixed(2);
    }
    return format.replace(placeholderRegex, formatted);
  }

  function card(product) {
    var image = product.images && product.images[0] ? product.images[0].src : '';
    var price = product.variants && product.variants[0] ? product.variants[0].price : '0';
    return [
      '<a href="/products/' + product.handle + '" class="sz-catalog-card">',
        '<span class="sz-catalog-card__media">',
          image ? '<img src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '<span class="sz-catalog-card__placeholder">' + product.title.slice(0, 1) + '</span>',
          '<span class="sz-catalog-card__badge">10 meals</span>',
        '</span>',
        '<span class="sz-catalog-card__body">',
          '<span class="sz-catalog-card__rating">★★★★★ <em>4.9</em></span>',
          '<strong>' + product.title + '</strong>',
          '<span class="sz-catalog-card__bottom">',
            '<span class="sz-catalog-card__price">' + money(price) + '</span>',
            '<span class="sz-catalog-card__cta">Discover</span>',
          '</span>',
        '</span>',
      '</a>'
    ].join('');
  }

  function injectStyles() {
    if (document.getElementById('sz-cache-catalog-styles')) return;
    var style = document.createElement('style');
    style.id = 'sz-cache-catalog-styles';
    style.textContent = [
      '.sz-catalog{background:linear-gradient(180deg,#fffaf1 0%,#fff 58%,#fffaf1 100%)}',
      '.sz-heading--catalog{margin-bottom:28px}',
      '.sz-catalog__grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:18px}',
      '.sz-catalog-card{display:grid;grid-template-rows:auto 1fr;overflow:hidden;min-height:100%;border:1px solid #ebe6dc;border-radius:8px;background:#fff;color:#2C2826;text-decoration:none;box-shadow:0 12px 34px rgba(39,36,30,.055);transition:transform .22s ease,box-shadow .22s ease,border-color .22s ease}',
      '.sz-catalog-card:hover{transform:translateY(-4px);border-color:rgba(37,70,51,.28);box-shadow:0 22px 54px rgba(39,36,30,.11)}',
      '.sz-catalog-card__media{position:relative;display:grid;place-items:center;aspect-ratio:1/1;background:radial-gradient(circle at 50% 42%,#fff 0%,#fff 56%,#f8f4ec 100%);overflow:hidden}',
      '.sz-catalog-card__media img{width:100%;height:100%;object-fit:contain;padding:22px;display:block;transition:transform .28s ease}',
      '.sz-catalog-card:hover .sz-catalog-card__media img{transform:scale(1.035)}',
      '.sz-catalog-card__badge{position:absolute;left:12px;top:12px;padding:6px 9px;border-radius:999px;background:rgba(37,70,51,.92);color:#fff;font-size:11px;font-weight:900;letter-spacing:.02em}',
      '.sz-catalog-card__placeholder{display:grid;place-items:center;width:88px;height:88px;border-radius:50%;background:#edf5ee;color:#254633;font-size:36px;font-weight:900}',
      '.sz-catalog-card__body{display:grid;align-content:start;gap:9px;padding:15px 16px 16px;background:#fff}',
      '.sz-catalog-card__rating{color:#e8b83f;font-size:12px;letter-spacing:1px;line-height:1}',
      '.sz-catalog-card__rating em{color:#716a61;font-style:normal;font-weight:800;letter-spacing:0;margin-left:5px}',
      '.sz-catalog-card__body strong{min-height:42px;color:#2C2826;font-size:15px;line-height:1.28;font-weight:850}',
      '.sz-catalog-card__bottom{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:2px;min-width:0}',
      '.sz-catalog-card__price{flex:0 0 auto;color:#1f2f25;font-size:20px;line-height:1;font-weight:950;white-space:nowrap}',
      '.sz-catalog-card__cta{display:inline-flex;align-items:center;justify-content:center;min-height:32px;padding:8px 12px;border-radius:999px;background:#edf5ee;color:#254633;font-size:12px;font-weight:950;text-transform:uppercase;letter-spacing:.08em}',
      '.sz-catalog__footer{display:flex;justify-content:center;margin-top:30px}',
      '@media(max-width:980px){.sz-catalog__grid{grid-template-columns:repeat(2,minmax(0,1fr))}}',
      '@media(max-width:680px){.sz-catalog__grid{gap:12px}.sz-catalog-card__media img{padding:16px}.sz-catalog-card__body{padding:12px;gap:7px}.sz-catalog-card__body strong{min-height:48px;font-size:13px}.sz-catalog-card__price{font-size:17px}.sz-catalog-card__cta{min-height:28px;padding:7px 9px;font-size:10px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function replaceStaleHome(products) {
    var staleCollections = document.querySelector('.sz-home .sz-collections');
    var staleProducts = document.querySelector('.sz-home .sz-products');
    if (!staleCollections || document.querySelector('.sz-catalog-card')) return;
    injectStyles();
    var section = document.createElement('section');
    section.className = 'sz-section sz-catalog';
    section.innerHTML = [
      '<div class="pv-wrap">',
        '<div class="sz-heading sz-heading--catalog">',
          '<span class="pv-kicker">Most loved</span>',
          '<h2>Choose the bracelet that funds 10 meals.</h2>',
          '<p>A clear selection, like a real boutique: visible products, readable prices and simple checkout.</p>',
        '</div>',
        '<div class="sz-catalog__grid">' + products.map(card).join('') + '</div>',
        '<div class="sz-catalog__footer"><a class="pv-btn pv-btn--honey" href="/collections/solidarity-bracelets">View all bracelets</a></div>',
      '</div>'
    ].join('');
    staleCollections.replaceWith(section);
    if (staleProducts) staleProducts.remove();
  }

  function initCacheGuard() {
    if (!document.querySelector('.sz-home .sz-collections')) return;
    fetch('/collections/solidarity-bracelets/products.json?limit=8', { credentials: 'same-origin' })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(data) {
        if (data && data.products && data.products.length) replaceStaleHome(data.products);
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCacheGuard);
  } else {
    initCacheGuard();
  }
})();
